<div
	class="--report-header flex flex-col justify-stretch"
	id="header"
>
	@if (visibleNav$ | async; as nav) {
	<tg-toolbar
		[showUser]="true"
		tbclass="mat-toolbar-tg mat-toolbar-base h-initial"
	>
		<ng-template tgToolbarControls>
			<div class="flex flex-auto flex-row items-center justify-start gap-3">
				<div
					[class.nav-container-teams]="isTeams"
					class="nav-container flex flex-row items-center justify-start"
				>
					<a
						[routerLinkActiveOptions]="{
							paths: 'exact',
							fragment: 'ignored',
							matrixParams: 'ignored',
							queryParams: 'ignored',
						}"
						*ngIf="nav.permission.projectPermission"
						class="nav-item dash-nav-item"
						href="#"
						queryParamsHandling="merge"
						routerLink="/dashboard"
						routerLinkActive="active"
					>
						{{ 'reports.summary' | translate }}
					</a>
					<a
						*ngIf="nav.permission.projectPermission"
						class="nav-item dash-nav-item"
						href="#"
						queryParamsHandling="merge"
						routerLink="/dashboard/detailed"
						routerLinkActive="active"
						>{{
							'reports.detailed' | translate
						}}</a
					>
					@if( !(comegoEnabled$ | async ) && (scheduleEnabled$ | async) &&
					nav.permission.workingHoursPermission ) {
					<div class="mx-3">
						<mat-divider
							class="h-8 rotate-6"
							inset
							vertical
						></mat-divider>
					</div>
					<a
						class="nav-item dash-nav-item"
						href="#"
						queryParamsHandling="merge"
						routerLink="/dashboard/schedules"
						routerLinkActive="active"
						>{{
							'reports.schedule' | translate
						}}</a
					>
					} @if( comegoEnabled$ | async ) { @if (nav.permission.workingHoursPermission) { @if
					(nav.showDivider) {
					<div class="mx-3">
						<mat-divider
							class="h-8 rotate-6"
							inset
							vertical
						></mat-divider>
					</div>
					}
					<a
						class="nav-item dash-nav-item"
						href="#"
						queryParamsHandling="merge"
						routerLink="/dashboard/schedules"
						routerLinkActive="active"
						>{{
							'reports.schedule' | translate
						}}</a
					>
					} @if (nav.permission.timecontingentPermission) {
					<a
						class="nav-item dash-nav-item"
						href="#"
						queryParamsHandling="merge"
						routerLink="/dashboard/contingent"
						routerLinkActive="active"
						>{{
							'reports.contingent' | translate
						}}</a
					>
					}}
				</div>
				<div
					*ngIf="nav.project || nav.workinghoursExport"
					class="flex flex-auto flex-row items-center justify-start gap-2"
					fxHide.lt-sm
				>
					<div class="flex-auto"></div>
					<tg-reports-toolbar-actions
						(goBack)="goBack()"
						(openExport)="openExportDialog()"
						(openRounding)="openRoundingDialog()"
						(saveDashboard)="savedDashboardMenu(true, updateOrNewTemplate, confirmUpdateDialog)"
						(share)="shareFilters()"
						[exportDisabled$]="exportDisabled$"
						[showBack]="!!lastContingentUrl.value"
						[showExport]="(exportVisible$ | async) === true"
						[showRounding]="currentPage.value !== 'workinghours' && currentPage.value !== 'contingent'"
						[showSave]="!(isDefaultFilter$ | async)"
						[theme$]="theme"
						[timeLoading$]="timeLoading$"
					></tg-reports-toolbar-actions>
				</div>
			</div>
		</ng-template>
		<ng-template tgToolbarRightControls>
			<button
				[matMenuTriggerFor]="moreSettingsMenu"
				fxHide.gt-sm
				mat-icon-button
			>
				<mat-icon>more_vert</mat-icon>
			</button>
			<mat-menu #moreSettingsMenu="matMenu">
				<button
					(click)="shareFilters()"
					mat-menu-item
				>
					<mat-icon>share</mat-icon>
					<span translate>reports.share</span>
				</button>
				<button
					(click)="this.openRoundingDialog()"
					[class.mat-accent]="(this.roundingData$ | async)?.enabled"
					mat-menu-item
				>
					<mat-icon>history</mat-icon>
					<span translate>Rounding</span>
				</button>
				<button
					(click)="openExportDialog()"
					mat-menu-item
				>
					<mat-icon>file_download</mat-icon>
					<span translate>reports.export</span>
				</button>
			</mat-menu>
		</ng-template>
	</tg-toolbar>
	}
	<tg-reports-filter-bar
		(manageDashboards)="savedDashboardMenu(false)"
		(resetFilters)="resetFilter()"
		(showCompletedChange)="onProjectShowCompletedChange($event)"
	></tg-reports-filter-bar>
	@if ((showFilters$ | async)?.enabled) {
	<ng-container *ngTemplateOutlet="favDashboards"></ng-container>
	}
	<mat-menu
		(click)="$event.stopPropagation()"
		#settingsMenu="matMenu"
	>
		<div class="mat-menu-item flex flex-row items-center justify-start gap-1.5">
			<mat-checkbox
				(change)="this.setTeam($event)"
				[checked]="!!(this.teamData | async)"
				color="primary"
			>
				<div class="flex flex-row items-center justify-start gap-1.5">
					<mat-icon>people</mat-icon>
					<span>{{ 'utils.show-team' | translate }}</span>
				</div>
			</mat-checkbox>
		</div>
	</mat-menu>
	<mat-menu
		(click)="$event.stopPropagation()"
		#downloadMenu="matMenu"
		class="export-menu"
	>
		<button
			[matMenuTriggerFor]="excelAdvancedMenu"
			[matMenuTriggerRestoreFocus]="false"
			color="primary"
			mat-menu-item
		>
			<div class="flex flex-row items-center justify-start gap-2">
				<ms-icon
					[icon]="'ExcelDocument'"
					style="font-size: 20px; height: 20px; width: 20px"
				></ms-icon>
				<span>{{ 'utils.excel-download' | translate }}</span>
			</div>
		</button>
		<button
			(click)="this.downloadCsv()"
			color="primary"
			mat-menu-item
		>
			<div class="flex flex-row items-center justify-start gap-2">
				<ms-icon
					[icon]="'AnalyticsReport'"
					style="font-size: 20px; height: 20px; width: 20px"
				></ms-icon>
				<span>{{ 'utils.csv-download' | translate }}</span>
			</div>
		</button>
		<button
			(click)="this.openFlow()"
			*ngIf="projecthoursEnabled$ | async"
			color="primary"
			mat-menu-item
		>
			<div class="flex flex-row items-center justify-start gap-2">
				<ms-icon
					[icon]="'MicrosoftFlowLogo'"
					style="font-size: 20px; height: 20px; width: 20px"
				></ms-icon>
				<span>{{ 'utils.automatisation' | translate }}</span>
			</div>
		</button>
	</mat-menu>
</div>
<div class="container-wrapper">
	<div class="container-content"><router-outlet></router-outlet></div>
</div>
<mat-menu
	#excelAdvancedMenu="matMenu"
	class="export-menu"
>
	<button
		(click)="this.downloadExcel({ groupedByProject: true, timeZone: 'ADJUST' })"
		color="primary"
		mat-menu-item
	>
		<div class="flex flex-row items-center justify-start gap-2">
			<span>{{ 'utils.excel-download-grouped' | translate }}</span>
		</div>
	</button>
	<button
		(click)="this.downloadExcel({ groupedByProject: false, timeZone: 'ADJUST' })"
		color="primary"
		mat-menu-item
	>
		<div class="flex flex-row items-center justify-start gap-2">
			<span>{{ 'utils.excel-download-simple' | translate }}</span>
		</div>
	</button>
	<button
		(click)="this.downloadExcel({ groupedByProject: true, timeZone: 'KEEP' })"
		color="primary"
		mat-menu-item
	>
		<div class="flex flex-row items-center justify-start gap-2">
			<span>{{ 'utils.excel-download-grouped-keep' | translate }}</span>
		</div>
	</button>
	<button
		(click)="this.downloadExcel({ groupedByProject: false, timeZone: 'KEEP' })"
		color="primary"
		mat-menu-item
	>
		<div class="flex flex-row items-center justify-start gap-2">
			<span>{{ 'utils.excel-download-simple-keep' | translate }}</span>
		</div>
	</button>
</mat-menu>
<ng-template
	#activeFiltersHoverCard
	let-filtersActivated="active"
>
	<div class="flex flex-row items-center justify-start gap-2">
		<span>Filter</span>
		<ng-container *ngIf="filtersActivated">
			<mat-divider
				class="h-4"
				vertical
			></mat-divider>
			<span>{{ filtersActivated }}</span>
		</ng-container>
	</div>
</ng-template>
<ng-template #loadingCircle>
	<div
		class="flex flex-col items-center justify-center"
		style="width: 40px; height: 40px"
	>
		<mat-progress-spinner
			[diameter]="20"
			[mode]="'indeterminate'"
			[strokeWidth]="2"
			color="primary"
		></mat-progress-spinner>
	</div>
</ng-template>
<ng-template
	#scheduleTypeTemplate
	let-type
>
	<span>{{ 'schedules.dashboard.type-' + type | translate }}</span>
</ng-template>

<ng-template #favDashboards>
	<mat-toolbar
		*ngIf="((dashboardsPinnedByUser | async)?.length ?? 0) > 0"
		class="mat-toolbar-secondary mat-toolbar-mw scroll-auto"
	>
		<div class="flex flex-auto flex-row items-center justify-start gap-4 pb-2 pt-3">
			<div class="flex flex-auto flex-row items-center justify-start gap-2">
				<div
					*ngIf="dashboardsPinnedByUser | async as dashboards"
					class="flex flex-auto items-center space-x-2"
				>
					<!-- Liste von fav dashboards -->
					<div class="mat-hint mat-typography font-bold pt-1">
						<button
							(click)="savedDashboardMenu()"
							matTooltip=" {{ 'dashboard.manage' | translate }}"
						>
							<mat-icon color="accent">star</mat-icon>
						</button>
					</div>
					<ng-container>
						<div class="overflow-x-auto whitespace-nowrap px-2 py-1">
							<!-- [class.active]="auditFilter$active | async" -->
							<button
								(click)="applyDashboard(refItem, true)"
								[class.active]="activeFavDashboard?.value?.id == refItem.id"
								[matTooltip]="refItem.displayName"
								*ngFor="let refItem of dashboards"
								class="mat-button-alt inline-block mr-2"
							>
								<div class="flex flex-row items-center justify-start gap-1">
									<mat-icon
										[ngStyle]="{ color: refItem.color }"
										inline
									>
										bookmark
									</mat-icon>
									<span>{{ refItem.displayName | truncate: '25' }}</span>
								</div>
							</button>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</mat-toolbar>
</ng-template>
<ng-template
	#updateOrNewTemplate
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">
			<div class="flex flex-row items-center justify-start gap-2">
				<div>{{ 'reports.updateOrCreateNew' | translate }}</div>
				<div class="flex-auto"></div>
				<button
					(click)="ref.close(false)"
					mat-icon-button
					matDialogClose
				>
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</h4>
	</div>
	<mat-dialog-content> <p>{{ 'dashboard.updateOrNewDialog' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(1)"
			mat-stroked-button
		>
			{{ 'dashboard.update' | translate }}
		</button>
		<button
			(click)="ref.close(2)"
			mat-stroked-button
		>
			{{ 'dashboard.new' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>

<ng-template
	#confirmUpdateDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<mat-dialog-content> <p>{{ 'dashboard.confirmUpdate' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.confirm' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
